export class ChannelDropdownSettingsModel {
  singleSelection: boolean;
  enableCheckAll: boolean;
  text: string;
  selectAllText: string;
  unSelectAllText: string;
  enableSearchFilter: boolean;
  classes: string;
}



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/calendar/channel-dropdown-settings.model.ts